import { Box, Typography } from "@mui/material";
import ChartComponent from "../../ChartComponent/ChartComponent";
import { useIntl } from "react-intl";
import Messages from "../../../../../localization/Messages";
import { StatsCountShips } from "../../../../../models/stats";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

type ShipDataBookingsAnalyticsProps = {
    statsCountShips: StatsCountShips[];
};

export const ShipDataBookingsAnalytics = ({ statsCountShips }: ShipDataBookingsAnalyticsProps) => {
    const intl = useIntl();
    const dataAvailable = statsCountShips.length > 0;

    const averageNumberOfBeds = dataAvailable
        ? Math.floor(statsCountShips[0].beds / statsCountShips[0].count)
        : 0;

    return (
        <Box className="ship-data-for-bookings-container shadow" my={2} mx={2.5} padding={2.5}>
            <Typography variant="h5">
                {intl.formatMessage(Messages.shipDataForBookings)}
                <Tooltip title={intl.formatMessage(Messages.onlyInvoicedConfirmedChangedTooltip)}>
                    <HelpOutlineIcon fontSize="small" color="action" />
                </Tooltip>
            </Typography>
            <ChartComponent
                data={
                    dataAvailable
                        ? [
                              {
                                  label: `${intl.formatMessage(Messages.vesselsShorterThan)} 110m`,
                                  value: statsCountShips[0].le110,
                              },
                              {
                                  label: `${intl.formatMessage(Messages.vesselsLongerThan)} 110m`,
                                  value: statsCountShips[0].gt110,
                              },
                          ]
                        : []
                }
                description={intl.formatMessage(Messages.numberOfVesselsByLength)}
                outerStats={[
                    `${intl.formatMessage(Messages.totalNumberOfShips)} = ${
                        statsCountShips[0]?.count ?? 0
                    }`,
                    `${intl.formatMessage(Messages.averageNumberOfBeds)} = ${averageNumberOfBeds.toFixed(2)}`,
                ]}
                height={150}
                formatter={value =>
                    `${value} / ${((value / statsCountShips[0].count) * 100).toFixed(2)}%`
                }
            />
        </Box>
    );
};
